import { ref } from 'vue';
import { defineStore } from 'pinia';

// // Utils imports
import identifiers from '@/utils/identifiers';
import BeaconManager from '@/utils/beaconManager';

export const useGeneralStore = defineStore('general', () => {
  const instance = ref({
    // designation: identifiers.getHostnameBasedDesignationId() || process.env.NODE_ENV,
    designation: identifiers.getHostnameBasedDesignationId(),
    fullUrl: window.location.href,
    hashFragment: window.location.hash,
    hostName: window.location.hostname,
    pathName: window.location.pathname,
    portNumber: window.location.port,
    protocolScheme: window.location.protocol,
    searchString: window.location.search,
    beaconManager: new BeaconManager(),
  });

  // // Actions

  //

  // // Getters

  //

  return {
    instance,
  };
});
